import * as Vue from 'vue'
import * as VueRouter from 'vue-router'
import lbl from './lbl'

export default VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes: lbl,
})
